/* eslint-disable @typescript-eslint/unbound-method */

import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import { primaryHoverColor } from "./colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const its4 = definePartsStyle({
  field: {
    border: "1px solid",
    borderColor: "#807a7a",
    background: "gray.50",
    _focusVisible: {
      borderColor: primaryHoverColor,
      boxShadow: `0 0 0 1px ${primaryHoverColor}`,
    },
  },
});

export const inputTheme = defineMultiStyleConfig({
  variants: { its4 },
  defaultProps: { variant: "its4" },
});
